<template>
    <div class="block-editor set-department">
        <div class="title">Department Selection Type</div>
        <div class="methods">
            <span class="method" :class="{ selected: clone.method === 'static' }" @click="() => changeMethod('static')"
                >Static</span
            >
            <span
                class="method"
                :class="{ selected: clone.method === 'dynamic' }"
                @click="() => changeMethod('dynamic')"
                >Dynamic</span
            >
        </div>

        <div v-if="clone.method === 'static'" class="mt-3">
            <div class="attribute-picker-section">
                <span class="sectionTitle"> Choose Department From List</span>
                <a-select :value="clone.departmentId" @change="changeDepartment" class="select-filetype">
                    <a-select-option :value="department._id" v-for="department of subjects" :key="department._id"
                        >{{ getSubjectTitle(department) }}
                    </a-select-option>
                </a-select>
            </div>
        </div>
        <div v-else class="mt-3">
            <div class="attribute-picker-section">
                <span class="sectionTitle"> Choose Department From Attributes</span>
                <a-popover
                    v-model="attributePickerVisible"
                    trigger="click"
                    :overlayClassName="'no-padding'"
                    placement="left"
                >
                    <div slot="content">
                        <AttributePicker default-selected="department" :pick="onAttributePicked" />
                    </div>
                    <div class="attribute-input">
                        <div class="attribute-input-text-wrapper">
                            <div class="attribute-input-placeholder" v-if="$_.isEmpty(clone.departmentId)">
                                Choose Department From Attributes
                            </div>
                            <div class="single-attribute-style" v-else :class="{ active: attributePickerVisible }">
                                <AttributeIconPreview :attribute="clone.departmentId" />
                                <span>{{ clone.departmentId }}</span>
                            </div>
                        </div>
                        <span class="material-icons" v-if="!$_.isEmpty(clone.departmentId)"> expand_more </span>
                    </div>
                </a-popover>
            </div>
        </div>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import AttributePicker from "../pickers/AttributePicker";
import _ from "lodash";
import AttributeIconPreview from "../common/AttributeIconPreview";
import { mapActions, mapState } from "vuex";

const log = log2("SetDepartment");
export default {
    name: "SetDepartment",
    components: { AttributePicker, AttributeIconPreview },
    props: {
        value: {
            type: Object,
            default: () => ({
                method: String, // static,dynamic
                departmentId: String,
            }),
        },
    },
    data() {
        return {
            clone: _.cloneDeep(this.value),
            attributePickerVisible: false,
        };
    },
    computed: {
        ...mapState({
            subjects: (state) => _.get(state.subject.subjects, "data", []) || [],
        }),
    },
    methods: {
        ...mapActions({
            getSubjects: "subject/getSubjects",
        }),
        onAttributePicked(attribute) {
            log("onAttributePicked", attribute);
            this.clone.deparmentId = attribute;
            this.attributePickerVisible = false;
        },
        getSubjectTitle(department) {
            const validLangs = Object.keys(department.languageContent);
            const targetLang = validLangs.includes(this.$i18n.locale) ? this.$i18n.locale : validLangs[0];
            const key = `languageContent.${targetLang}.name`;
            return _.get(department, key);
        },
        changeDepartment(e) {
            log("changeDepartment", e);
            this.clone.departmentId = e;
        },
        changeMethod(method) {
            this.clone.method = method;
            if (method === "static") {
                this.clone.departmentId = _.get(this.subjects, "[0]._id", null);
            } else {
                this.clone.departmentId = "department";
            }
        },
    },
    mounted() {
        log("mounted");
        this.getSubjects({ perPage: 1000, page: 1 });
    },
    watch: {
        clone: {
            deep: true,
            immediate: true,
            handler(newValue, oldValue) {
                this.$emit("input", newValue);
            },
        },
    },
};
</script>

<style lang="scss">
.set-department {
    padding: 30px 30px 105px;

    .methods {
        display: flex;
        gap: 5px;
        width: 100%;

        .method {
            padding: 10px;
            border: 1px solid #c6cdd4;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            cursor: pointer;
            width: 100%;

            &:hover {
                opacity: 0.8;
            }

            &.selected {
                border: 1px solid #006cff;
                background: #006cff;
                color: #fff;
            }
        }
    }

    .title {
        margin-bottom: 5px;
        color: #22272d;
        font-weight: 600;
        font-size: 16px;
        line-height: 20px;
    }

    .select-filetype {
        width: 100%;
        height: 43px;

        .ant-select-selection--single {
            height: 43px;
            cursor: pointer;
            display: flex;
            align-items: center;
        }
    }

    .attribute-picker-section {
        margin-top: 20px;

        .sectionTitle {
            margin-bottom: 10px;
            margin-top: 15px;
            color: #22272d;
            font-weight: 600;
            font-size: 16px;
            line-height: 20px;
        }

        .attribute-input {
            align-items: center;
            background: #fff;
            border: 1px solid #c6cdd4;
            border-radius: 6px;
            cursor: pointer;
            display: flex;
            height: 43px;
            padding: 15px;
            position: relative;
            transition: all 0.3s;
            user-select: none;
            width: 100%;

            &:hover {
                border: 1px solid #006cff !important;
            }

            .attribute-input-text-wrapper {
                display: flex;
                flex-grow: 1;
                width: 0;
            }

            .attribute-input-placeholder {
                color: #9ba6b3;
                font-size: 15px;
                line-height: 19px;
                overflow: hidden !important;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .single-attribute-style {
                background: #ffdc66;
                cursor: pointer;
                transition: all 0.3s;
                border-radius: 10px;
                box-decoration-break: clone;
                padding: 0 8px;
                display: flex;
                justify-content: center;
                align-items: center;
                font-weight: 800;

                &.active {
                    background: #006cff;
                    color: #fff;

                    .material-icons {
                        color: #fff;
                    }
                }

                .material-icons {
                    color: #647283;
                    font-size: 18px;
                    margin-right: 3px;
                }
            }
        }
    }
}
</style>
